<template>
  <div v-if="htmlSnippet" class="htmlSnippet-box">
    <span v-if="isImage" class="wallet-filled img_wallet"></span>
    <div v-html="result"></div>
  </div>
</template>

<script setup>
import * as a from '~/utils/UserStatus';

const props = defineProps({
  htmlSnippet: {
    type: Object,
    default: null,
  },
});

const result = ref('');
const userName = ref('');
const isImage = ref(false);

onMounted(() => {
  userName.value = decodeURIComponent(a.getCookie('MISCGCs'));
  if (userName.value !== false && userName.value !== '') {
    result.value = updateWalletContent('find-out-moreid');
  } else {
    result.value = updateWalletContent('find-out-walletid');
  }
});

function updateWalletContent(id) {
  const html = props.htmlSnippet?.text;
  const temp = document.createElement('div');
  temp.innerHTML = html;

  Array.from(temp.getElementsByTagName('a')).forEach((ele) => {
    if (ele.id === id) {
      ele.style.display = 'none';
    }
    if (ele.id === 'find-out-moreid') {
      ele.classList.remove('button');
      ele.href = 'https://www.macys.com/p/wallet/faq/';
      ele.style.fontSize = '16px';
      ele.style.marginTop = '10px';
    }
    if (ele.id === 'find-out-walletid') {
      ele.style.fontSize = '14px';
      ele.style.borderRadius = '0';
      ele.style.fontWeight = '700';
      ele.style.marginTop = '10px';
      ele.style.color = '#fff';
      ele.style.backgroundColor = '#e01a2b';
      isImage.value = true;
      ele.href = '/account/wallet?ocwallet=true';
    }
  });

  Array.from(temp.getElementsByTagName('h4')).forEach((ele1) => {
    ele1.innerHTML = userName.value !== false && userName.value !== '' ? `${userName.value}'s Wallet` : 'Wallet';
    ele1.style.marginBottom = '6px';
  });

  Array.from(temp.getElementsByClassName('wallet-desc')).forEach((el3) => {
    el3.style.paddingTop = '4px';
    el3.style.paddingBottom = '4px';
    el3.style.fontSize = '16px';
  });

  Array.from(temp.getElementsByClassName('promoHeaderTitles')).forEach((el4) => {
    el4.style.fontWeight = '700';
    el4.style.paddingBottom = '8px';
    el4.style.fontSize = '20px';
  });

  Array.from(temp.getElementsByClassName('promoHeaderTitlesWallet')).forEach((el5) => {
    el5.style.fontWeight = '700';
    el5.style.paddingBottom = '8px';
    el5.style.fontSize = '20px';
    el5.style.marginLeft = '40px';
  });
  return temp.innerHTML || '';
}
</script>

<style lang="scss" scoped>
@import '~@core/csg/src/scss/encodedIcons/mcom/wallet-filled.scss';

div {
  display: inline-block;
  justify-content: flex-start;
  align-content: stretch;
  align-items: stretch;
  background-color: $white;
  margin-top: rem-calc(8);
  margin-bottom: rem-calc(20);
  padding: rem-calc(10 10 10);
  width: 100%;
}
.promoHeaderTitles {
  font-size: rem-calc(17) !important;
  font-weight: 700;
  color: $sale-color;
}
.promo-wallet-icon {
  .button1 {
    background-color: none;
    text-decoration: underline;
    color: $black;
  }
}
:v-deep(.small-16 .columns) {
  font-size: rem-calc(16);
}
.img_wallet {
  position: absolute;
  margin-top: rem-calc(20);
}
</style>
